import { CORE_PLUGIN, CORE_ROUTER } from "@/core"
import type { ConsolePageOption, ConsolePageService, Plugin } from "@/plugins"
import { PLUGIN_CONSOLE_PAGE } from "@/plugins/builtin/BuiltinPluginSymbol"
import { container, injectable, instanceCachingFactory, registry, singleton } from "tsyringe"
import type { App, ToRefs, Ref } from "vue"
import type { Router } from "vue-router"
import { useRouter } from 'vue-router'
import { CUSTOMABLE_IMAGE_SERVICE, DefaultCustomableImageService, type CustomableImageService } from "./service/CustomableImageService"
import { DefaultShoppingCartService, SHOPPING_CART_SERVICE, type ShoppingCartService } from "./service/ShoppingCartService"
import CustomSpu from "./view/CustomSpu.vue"
import CustomSpuDesigner from "./view/CustomSpuDesigner.vue"
import CustomSpuService from "./view/CustomSpuService.vue"
import CustomSpusVue from "./view/CustomSpus.vue"
import CustomSpuDesignerMini from "./view/CustomSpuDesignerMini2D.vue"
import ShoppingCart from "./view/ShoppingCart.vue"
import { defineStore, storeToRefs } from 'pinia'
import type { CustomSpu as CustomSpuType, Color, CustomAreaAdjustment } from './types'
export * from "./service/CustomableImageService"
export * from "./service/ShoppingCartService"

export const selectedSpuData = defineStore('selectedSpuData', {
  state: () => ({
    customSpu: undefined as CustomSpuType | undefined,
    selectedColor: undefined as Color | undefined,
    customAreaAdjustment: {
      flipHorizontal: false, // 水平翻转
      flipVertical: false, // 垂直翻转
      fontBold: false, // 粗体字体
      fontItalic: false, // 字体斜体
      linethrough: false, // 中划线
      underline: false, // 下划线
      rotate: 0, // 旋转
      fontColor: '#ffffff', // 字体颜色
      fontFamily: '', // 字体
      fontSize: 36, // 字体大小
      strokeWidth: 0, // 字体边缘粗度
      strokeColor: '#000000', // 字体边缘颜色
      textAlign: 'left', // left center right 对齐方式
      maximize: false, // 最大化
      spreadOut: false, // 平铺
      heightMaximization: false, // 高度最大化
      widthMaximization: false, // 宽度最大化
    } as CustomAreaAdjustment
  }),
  actions: {
    pathJudgment() {
      const router = useRouter().options.history.state.back
      if (router && typeof router === 'string' && router.includes('/console/products/custom_spus/'))
        return this.$state.customSpu
      else
        this.$state.customSpu = undefined
    }
  }
})

export type AccountInfoOption = {
  customSpu: Ref<CustomSpuType>
  selectedColor: Ref<Color>
}

/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) => c.resolve(CustomSpus))
  }
])
@injectable()
export class CustomSpus implements Plugin<unknown, unknown> {
  id: string | symbol = "";
  options: unknown
  service: unknown
  constructor() {
    const instantiationStore = selectedSpuData()
    const options = storeToRefs(instantiationStore)
    this.service = instantiationStore
    this.options = options as ToRefs<AccountInfoOption>
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const router = container.resolve<Router>(CORE_ROUTER)
    router.addRoute({ path: "/products/custom_spus_design", component: CustomSpuDesigner, name: "CustomSpuDesigner" })
    router.addRoute({ path: "/products/custom_spus_service", component: CustomSpuService, name: "CustomSpuService" })
    router.addRoute({ path: "/products/custom_spus_design_mini", component: CustomSpuDesignerMini, name: "CustomSpuDesignerMini" })
    app.component("ShoppingCartDrawer", ShoppingCart)
    const plugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    plugin.service.addChildRoute({
      path: "products/custom_spus/:id",
      name: 'customDetail',
      component: CustomSpu
    })
    plugin.service.addChildRoute({
      path: "products/custom_spus",
      name: 'customSpus',
      component: CustomSpusVue
    })
    // plugin.service.addChildRoute({
    //   path: 'products/custom_spus_design_mini',
    //   component: CustomSpuMini,
    // })
    const consolePlugin = container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(PLUGIN_CONSOLE_PAGE)
    consolePlugin.service.addHeadRight("shopping-cart-drawer")
    //
    container.register<ShoppingCartService>(SHOPPING_CART_SERVICE, { useValue: new DefaultShoppingCartService() })
    //
    container.register<CustomableImageService>(CUSTOMABLE_IMAGE_SERVICE, { useValue: new DefaultCustomableImageService() })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void { }
}
